import { render, staticRenderFns } from "./MFAVerificationModal.vue?vue&type=template&id=a22e9404&scoped=true"
import script from "./MFAVerificationModal.vue?vue&type=script&lang=ts"
export * from "./MFAVerificationModal.vue?vue&type=script&lang=ts"
import style0 from "./MFAVerificationModal.vue?vue&type=style&index=0&id=a22e9404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22e9404",
  null
  
)

export default component.exports